<template>
  <v-list three-line>
    <template
      v-for="(item, index) in items"
    >
      <v-divider v-if="index != 0" :key="index + 100000" />
      <v-list-item
        class="pa-3"
        target="_blank"
        @click="item.onClick"
        :href="item.href"
        :key="item.key"
      >
        <v-list-item-avatar v-if="item.icon">
          <v-icon class="primary white--text">{{item.icon}}
          </v-icon>
        </v-list-item-avatar>

        <v-list-item-content :class="{'align-title': !item.subtitle}">
          <v-list-item-title>
            <strong>
              {{ item.title }}
              <v-icon
                :color="item.titleIconColor"
                small
                v-if="item.titleIcon"
              >
                {{ item.titleIcon }}
              </v-icon>
            </strong>
          </v-list-item-title>

          <v-list-item-subtitle
            v-for="(subtitle, subIndex) in filterSubtitles(item.subtitles)"
            :key="subIndex + 200000"
          >
            <strong>{{ subtitle.name }} :</strong> {{ subtitle.description }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-avatar tile height="100" width="100">
          <v-img v-if="item.imageUrl" :src="item.imageUrl" />
        </v-list-item-avatar>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
import { filter } from 'lodash';

export default {
  name: 'BaseList',
  props: {
    items: {
      required: true,
      type: Array,
    },
  },
  methods: {
    filterSubtitles(subtitles) {
      return filter(subtitles, 'description');
    },
  },
};
</script>

<style lang="scss" scoped>
  .align-title {
    display: block;
    padding-top: 25px;
  }
</style>
